import { render, staticRenderFns } from "./autoMethod.vue?vue&type=template&id=4af1a729&scoped=true&"
import script from "./autoMethod.vue?vue&type=script&lang=js&"
export * from "./autoMethod.vue?vue&type=script&lang=js&"
import style0 from "./autoMethod.vue?vue&type=style&index=0&id=4af1a729&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1a729",
  null
  
)

export default component.exports